/*
Author: Pooja
Story: ENT-3555
 */

import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AbstractModalComponent } from '../../../abstract-modal/abstract-modal.component';
import { ConstantsService } from '../../../../services/constants/constants.service';
import { OrganisationService } from '../../../../services/organisation/organisation.service';
import { WarningModalService } from '../../../../services/warning-modal/warning-modal.service';
import { forkJoin } from 'rxjs';
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-xref-add-pulse-recipient-modal',
  templateUrl: './xref-add-pulse-recipient-modal.component.pug',
  styleUrls: ['./xref-add-pulse-recipient-modal.component.scss'],
  standalone: false
})
export class XrefAddPulseRecipientModalComponent extends AbstractModalComponent implements OnInit {

  public nextClick: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('requestForm', {static: false}) requestForm: any;
  total = 0;
  errorMessage = {};
  domains: any;
  departments: any;
  errorTotalPulses = $localize`The number of total recipients for pulse surveys cannot exceed 5000. `
  personalEmailAddressTooltip = $localize`Only required if work email address is unavailable.`
  recipient = {
    firstName: '',
    lastName: '',
    work_email: '',
    work_email_domain: '',
    personal_email: '',
    country_code: '',
    mobile_phone: '',
    department: '-1'
  }
  disableSend = true;
  saved = false;
  invalid_work_email: boolean = false;
  emailOutOfFocus: boolean = false;
  personalEmailOutOfFocus: boolean = false;
  mobileNumberTouched: boolean = false;
  dropdownTouched: boolean = false;
  loading = false;

  constructor(public _bsModalRef: BsModalRef,
              public modal: WarningModalService,
              private organisationService: OrganisationService,
              private permissions: PermissionsService
              ) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {

    this.checkTotalRecipients();
    forkJoin({ orgDetails: this.organisationService.getOrganisation(), orgDepartments: this.organisationService.getAllDepartments(true)})
      .subscribe(({ orgDetails, orgDepartments }) => {
      this.domains = orgDetails['domains'];
      this.departments = orgDepartments['departments'].filter(each => !each.disabled)
      this.recipient['work_email_domain'] = this.domains[0];
      this.loading = true;
    });
  }

  changeValue() {
    this.getWorkEmailAddress(this.recipient.work_email)

    // making sure that all fields are mandatory but either work email or personal email is entered before add recipient
    if (this.recipient.firstName.trim() && this.recipient.lastName.trim() && (this.recipient.mobile_phone!=='' && this.recipient.mobile_phone!==null && this.recipient.mobile_phone!=='null' ) && this.recipient.department !== '' && this.recipient.department !== '-1' && (this.recipient.personal_email !== '' || (this.recipient.work_email !== '' && this.recipient.work_email_domain !==''))) {
      this.disableSend = false;
      this.checkTotalRecipients();
    } else {
      this.disableSend = true;
    }
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  getWorkEmailAddress(workEmail:string){
    if(workEmail !== '' ){
      this.invalid_work_email = workEmail.includes('@');
    }
  }

  checkWorkEmail(workEmail) {
    const mailRegex = /^[a-zA-Z0-9._%+-]+$/
    return mailRegex.test(workEmail)
  }

  addRecipient() {
    this.saved = true;
    if (!this.recipient.mobile_phone) this.recipient.country_code = '';
    let workEmail = this.recipient.work_email ? this.recipient.work_email + '@' + this.recipient.work_email_domain: '';
    let payload = {
      "first_name": this.recipient.firstName,
      "last_name": this.recipient.lastName,
      "work_email": workEmail,
      "personal_email": this.recipient.personal_email,
      "country_code": this.recipient.country_code,
      "mobile_phone": this.recipient.mobile_phone,
      "department": this.recipient.department,
    }

    if (this.recipient.firstName && this.recipient.lastName && this.recipient.mobile_phone && this.recipient.department !== '' && this.recipient.department !== '-1' && (this.recipient.personal_email !== '' || (this.recipient.work_email !== '' && this.recipient.work_email_domain !==''))) {
      this.disableSend = false;
      this.checkTotalRecipients();
      this.nextClick.emit({data: payload});
      this._bsModalRef.hide();
    }
  }

  getForm() {
    return this.requestForm;
  }

  phoneUpdate(event) {
    this.recipient.country_code = event['country_code'];
    this.recipient.mobile_phone = event['mobile_phone'] === 'null' ? '' : event['mobile_phone'];

    this.formDirty = true;
    this.changeValue();

  }

  checkTotalRecipients() {
    if (this.total >= ConstantsService.PULSES_RECIPIENTS_LIMIT) {
      this.disableSend = true;
      this.errorMessage = {
        'type': 'danger',
        'message': this.errorTotalPulses
      };
    }
  }
}
